import LandProviderPage from './LandProviderPage'
export default LandProviderPage
